import _ from 'lodash';
import { AnyAction } from 'redux';
import PaypalBatchFile from 'src/adminPanel/entities/offsetting/paypalBatches/PaypalBatchFile';
import PaypalBatchFileDetail from 'src/adminPanel/entities/offsetting/paypalBatches/PaypalBatchFileDetail';
import PaypalUnassignedOrder from 'src/adminPanel/entities/offsetting/paypalBatches/PaypalUnassignedOrder';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    FAILURE_PAYPAL_BATCHES,
    FAILURE_PAYPAL_BATCH_FILE_DETAILS,
    FAILURE_PAYPAL_UNASSIGNED_ORDERS,
    REQUEST_PAYPAL_BATCHES,
    REQUEST_PAYPAL_BATCH_FILE_DETAILS,
    REQUEST_PAYPAL_UNASSIGNED_ORDERS,
    SUCCESS_PAYPAL_BATCHES,
    SUCCESS_PAYPAL_BATCH_FILE_DETAILS,
    SUCCESS_PAYPAL_UNASSIGNED_ORDERS,
} from './actions';

export function paypalBatchReducerAdmin(
    state: EntityCollectionState<PaypalBatchFile> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_PAYPAL_BATCHES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_PAYPAL_BATCHES:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_PAYPAL_BATCHES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function paypalBatchFileDetailsReducerAdmin(
    state: EntityCollectionState<PaypalBatchFileDetail> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_PAYPAL_BATCH_FILE_DETAILS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_PAYPAL_BATCH_FILE_DETAILS:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_PAYPAL_BATCH_FILE_DETAILS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function paypalUnassignedOrdersReducerAdmin(
    state: EntityCollectionState<PaypalUnassignedOrder> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_PAYPAL_UNASSIGNED_ORDERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_PAYPAL_UNASSIGNED_ORDERS:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_PAYPAL_UNASSIGNED_ORDERS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
